export const BankAccountListPage = (destinationLang) => {
  return [
    {
      FormKey: "bank-account-list-navbar-title",
      Key: "ليست حساب ها",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-accordion-account-list",
      Key: "فهرست حساب هاي بانکي",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-select-bank",
      Key: "بانک",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-input-card-number",
      Key: "شماره کارت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-input-account-number",
      Key: "شماره حساب",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-shaba-number",
      Key: "شماره شبا",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-btn-activate-bank-account",
      Key: "فعالسازي حساب",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-btn-deactivate-bank-account",
      Key: "غير فعالسازي حساب",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-btn-add-new-bank-account",
      Key: "افزودن حساب",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-btn-edit-bank-account",
      Key: "ویرایش حساب",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "bank-account-list-alert-sure-delete",
      Key: "آیا از حذف حساب اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
  ];
};
